'use client';

import { ButtonCtaActionProps } from '../Inputs/Button';
import { tv } from '../_lib/utils';
import type { NavDropdownProps } from './DesktopNav/NavDropdown';
import { MobileNav } from './MobileNav';
import { DesktopNav } from './DesktopNav';
import { Brands } from '../Theme';

export const overlayStyles = tv({
	slots: {
		navOverlay: 'bg-overlay-video fixed bottom-0 left-0 right-0 top-0 transition-all duration-slow ease-smooth z-[29]',
	},
	variants: {
		navOpen: {
			true: {
				navOverlay: 'opacity-100 visible pointer-events-auto',
			},
			false: {
				navOverlay: 'opacity-0 invisible pointer-events-none',
			},
		},
	},
});

export type NavProps = {
	className?: string;
	nav: NavDropdownProps[];
	ctaNavButton?: ButtonCtaActionProps;
	featuredText?: string;
	defaultBrand?: Brands;
};
export function Nav(props: NavProps) {
	return (
		<nav data-component='Nav' className={`${props.className}`}>
			<DesktopNav {...props} ctaNavButton={props.ctaNavButton} />
			<MobileNav defaultBrand={props.defaultBrand} nav={props.nav} ctaNavButton={props.ctaNavButton} />
		</nav>
	);
}

export function NavOverlay(props: {
	isNavOpen: boolean;
	activeTab: number | undefined;
	setIsNavOpen?: (value: boolean) => void;
	setActiveTab?: (value: number | undefined) => void;
}) {
	const { navOverlay } = overlayStyles({
		navOpen: props.isNavOpen || props.activeTab !== undefined,
	});
	return (
		<div
			className={`${navOverlay()}`}
			onClick={() => {
				if (props.isNavOpen && props.setIsNavOpen) {
					props.setIsNavOpen(false);
				}
				if (props.activeTab !== undefined && props.setActiveTab) {
					props.setActiveTab(undefined);
				}
			}}
			role='presentation'
		/>
	);
}
